import React from 'react';
import { createContainer } from 'unstated-next';

const useBoardPosition = () => {
    const [positionX, setPositionX] = React.useState<number>();
    const [positionY, setPositionY] = React.useState<number>();
    const [scale, setScale] = React.useState<number>();
    console.log('happened');
    return {
        positionX,
        setPositionX,
        positionY,
        setPositionY,
        scale,
        setScale,
    };
};

export const BoardPosition = createContainer(useBoardPosition);
